import React, {Component} from 'react';
import "./RaikoInputStyleSheet.css"
import {css} from "@emotion/css";
import {useState} from "react";

const InputSubmitCodeRaiko = ({value, getCodeValue, labelText}) => {

    const [codeValue, setCodeValue] = useState(["", "", "", "", "", ""]);

    function setCode(position, value) {
        if (value !== " ") {

            const _code = [...codeValue]
            _code[position] = value
            setCodeValue(_code)


            let inputId = "input"

            if (value !== "" && position !== codeValue.length - 1) {
                inputId += position + 1
                document.getElementById(inputId).focus()
            } else if (value === "" && position !== 0) {
                inputId += position - 1
                document.getElementById(inputId).focus()
            }

            getCodeValue(_code.join(''))
        }
    }

    return (
        <div className="input-container">
            <label className="form-label">{
                labelText
            }</label>
            <div className={css`
              width: 100%;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              gap: .5rem;
              direction: ltr;
            `}>
                {
                    codeValue.map((item, index) => {
                        return <input
                            className="form-control form-control-submit-code"
                            spellCheck={"false"}
                            maxLength={1}
                            id={`input${index}`}
                            value={item}
                            onChange={({target}) => {
                                const _value = target.value
                                setCode(index, _value)
                            }}
                        />

                    })
                }
            </div>
        </div>
    )
};
export default InputSubmitCodeRaiko;